export const classes = {
  list: 'py-4 px-2 place-start',
  assignedTo: 'text-grey-7 ml-3 dark:text-mauve-2',
  profilePicture: 'cursor-default',
};
